import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
type State = {
	rgba_first_bg: { r: number; g: number; b: number; a: number };
	rgba_second_bg: { r: number; g: number; b: number; a: number };
	rgba_even_bg: { r: number; g: number; b: number; a: number };
	rgba_odd_bg: { r: number; g: number; b: number; a: number };
	rgba_light_bg: { r: number; g: number; b: number; a: number };
	rgba_border_clr: { r: number; g: number; b: number; a: number };
	rgba_border_size: number;
	rgba_border_style: string;
	ShowHightLight: boolean;
	ShowTextColor: boolean;
	scroll: number;
	// color text
	rgba_first_text: { r: number; g: number; b: number; a: number };
	rgba_second_text: { r: number; g: number; b: number; a: number };
	rgba_even_text: { r: number; g: number; b: number; a: number };
	rgba_odd_text: { r: number; g: number; b: number; a: number };
	rgba_light_text: { r: number; g: number; b: number; a: number };
};
type Action = {
	updateFirstBG: ( rgba_first_bg: State[ 'rgba_first_bg' ] ) => void;
	updateSecondBG: ( rgba_second_bg: State[ 'rgba_second_bg' ] ) => void;
	updateEvenBG: ( rgba_even_bg: State[ 'rgba_even_bg' ] ) => void;
	updateOddBG: ( rgba_odd_bg: State[ 'rgba_odd_bg' ] ) => void;
	updateLightBG: ( rgba_light_bg: State[ 'rgba_light_bg' ] ) => void;
	updateBorderClr: ( rgba_border_clr: State[ 'rgba_border_clr' ] ) => void;
	updateBorderSize: ( rgba_border_size: State[ 'rgba_border_size' ] ) => void;
	updateBorderStyle: (
		rgba_border_style: State[ 'rgba_border_style' ]
	) => void;
	updateShowHightLight: ( ShowHightLight: State[ 'ShowHightLight' ] ) => void;
	updateScroll: ( scroll: State[ 'scroll' ] ) => void;
	// color text update
	updateFirstText: ( rgba_first_text: State[ 'rgba_first_text' ] ) => void;
	updateSecondText: ( rgba_second_text: State[ 'rgba_second_text' ] ) => void;
	updateEvenText: ( rgba_even_text: State[ 'rgba_even_text' ] ) => void;
	updateOddText: ( rgba_odd_text: State[ 'rgba_odd_text' ] ) => void;
	updateLightText: ( rgba_light_text: State[ 'rgba_light_text' ] ) => void;
	updateShowTextColor: ( ShowTextColor: State[ 'ShowTextColor' ] ) => void;
};
// Create your store, which includes both state and (optionally) actions
export const useTimeTableColor = create< State & Action >()(
	devtools( ( set ) => ( {
		rgba_first_bg: { r: 0, g: 0, b: 0, a: 0 },
		rgba_second_bg: { r: 0, g: 0, b: 0, a: 0 },
		rgba_even_bg: { r: 0, g: 0, b: 0, a: 0 },
		rgba_odd_bg: { r: 0, g: 0, b: 0, a: 0 },
		rgba_light_bg: { r: 0, g: 0, b: 0, a: 0 },
		rgba_border_clr: { r: 0, g: 0, b: 0, a: 0 },
		rgba_border_size: 0,
		rgba_border_style: '',
		ShowHightLight: false,
		scroll: 0,
		// color text
		rgba_first_text: { r: 0, g: 0, b: 0, a: 0 },
		rgba_second_text: { r: 0, g: 0, b: 0, a: 0 },
		rgba_even_text: { r: 0, g: 0, b: 0, a: 0 },
		rgba_odd_text: { r: 0, g: 0, b: 0, a: 0 },
		rgba_light_text: { r: 0, g: 0, b: 0, a: 0 },
		ShowTextColor: false,

		updateFirstBG: ( rgba_first_bg ) =>
			set( () => ( { rgba_first_bg: rgba_first_bg } ) ),
		updateSecondBG: ( rgba_second_bg ) =>
			set( () => ( { rgba_second_bg: rgba_second_bg } ) ),
		updateEvenBG: ( rgba_even_bg ) =>
			set( () => ( { rgba_even_bg: rgba_even_bg } ) ),
		updateOddBG: ( rgba_odd_bg ) =>
			set( () => ( { rgba_odd_bg: rgba_odd_bg } ) ),
		updateLightBG: ( rgba_light_bg ) =>
			set( () => ( { rgba_light_bg: rgba_light_bg } ) ),
		updateBorderClr: ( rgba_border_clr ) =>
			set( () => ( { rgba_border_clr: rgba_border_clr } ) ),
		updateBorderSize: ( rgba_border_size ) =>
			set( () => ( { rgba_border_size: rgba_border_size } ) ),
		updateBorderStyle: ( rgba_border_style ) =>
			set( () => ( { rgba_border_style: rgba_border_style } ) ),
		updateShowHightLight: ( ShowHightLight ) =>
			set( () => ( { ShowHightLight: ShowHightLight } ) ),
		updateScroll: ( scroll ) => set( () => ( { scroll: scroll } ) ),

		// color update text
		updateFirstText: ( rgba_first_text ) =>
			set( () => ( { rgba_first_text: rgba_first_text } ) ),
		updateSecondText: ( rgba_second_text ) =>
			set( () => ( { rgba_second_text: rgba_second_text } ) ),
		updateEvenText: ( rgba_even_text ) =>
			set( () => ( { rgba_even_text: rgba_even_text } ) ),
		updateOddText: ( rgba_odd_text ) =>
			set( () => ( { rgba_odd_text: rgba_odd_text } ) ),
		updateLightText: ( rgba_light_text ) =>
			set( () => ( { rgba_light_text: rgba_light_text } ) ),
		updateShowTextColor: ( ShowTextColor ) =>
			set( () => ( { ShowTextColor: ShowTextColor } ) ),
	} ),
{ name: 'storeTimeTableColor' } )
);
